"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortArrObj = exports.getSortOrder = exports.sorter = void 0;
const sorter = (sortBy) => (a, b) => (a[sortBy] > b[sortBy] ? 1 : -1);
exports.sorter = sorter;
const getSortOrder = (entityName, order) => {
    return order?.length ? { [`${entityName}.${String(order[0].field)}`]: order[0].sort.toUpperCase() } : {};
};
exports.getSortOrder = getSortOrder;
const sortArrObj = (arr, options = {}) => {
    const { sortBy = "id" } = options;
    return arr.slice().sort((0, exports.sorter)(sortBy));
};
exports.sortArrObj = sortArrObj;
//# sourceMappingURL=sorter.js.map